var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.1329C17.3599 6.30612 16.7699 6.64427 16.2929 7.12132L9.12132 14.2929C8.64427 14.7699 8.30612 15.3599 8.1329 16H17C17.5523 16 18 15.5523 18 15V6.1329ZM20 6V15C20 16.6569 18.6569 18 17 18H8V41C8 41.5523 8.44772 42 9 42H36V7C36 6.44772 35.5523 6 35 6H20ZM14.8787 5.70711C15.9717 4.61406 17.4542 4 19 4H35C36.6569 4 38 5.34315 38 7V43C38 43.5523 37.5523 44 37 44H9C7.34315 44 6 42.6569 6 41V17C6 15.4542 6.61406 13.9717 7.70711 12.8787L14.8787 5.70711Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 16C23 15.4477 23.4477 15 24 15H32C32.5523 15 33 15.4477 33 16C33 16.5523 32.5523 17 32 17H24C23.4477 17 23 16.5523 23 16ZM11 22C11 21.4477 11.4477 21 12 21H32C32.5523 21 33 21.4477 33 22C33 22.5523 32.5523 23 32 23H12C11.4477 23 11 22.5523 11 22ZM11 28C11 27.4477 11.4477 27 12 27H32C32.5523 27 33 27.4477 33 28C33 28.5523 32.5523 29 32 29H12C11.4477 29 11 28.5523 11 28ZM11 34C11 33.4477 11.4477 33 12 33H32C32.5523 33 33 33.4477 33 34C33 34.5523 32.5523 35 32 35H12C11.4477 35 11 34.5523 11 34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceNv);
export default __webpack_public_path__ + "static/media/Invoice_nv.8e9b13c09e979cbea9d0eeafea75e9e4.svg";
export { ForwardRef as ReactComponent };